<script setup lang="ts">
import {Head, router, useForm} from "@inertiajs/vue3";
import Layout from "@/Pages/auth/layouts/AuthLayout.vue";
import TextField from "@/Pages/auth/components/TextField.vue";
import FormCard from "@/Pages/auth/components/FormCard.vue";
import SingleActionCard from "@/Pages/auth/components/SingleActionCard.vue";

interface Props {
  status?: string
}

defineOptions({layout: Layout})
defineProps<Props>()
const form = useForm({
    email: '',
    password: '',
    remember: true,
})

const submit = () => {
    form.post(route('login'), {
        onFinish: () => {
            form.reset('password')
        },
    })
}

const forgotPassword = () => {
    router.visit(route('password.request'))
}

const register = () => {
    router.visit(route('register'))
}
</script>

<template>
    <Head title="Sign in to SendCrypt" />
    <form-card
        :status="status"
        :loading="form.processing"
        :error-messages="form.errors.email || form.errors.password"
        @submit="submit"
    >
        <template #title>
            Sign in to SendCrypt
        </template>
        <text-field
            v-model="form.email"
            label="Email"
            type="email"
            autocomplete="email"
            :autofocus="true"
            :required="true"
            :hide-required-asterisk="true"
        />
        <text-field
            v-model="form.password"
            label="Password"
            type="password"
            autocomplete="current-password"
            :required="true"
            :hide-required-asterisk="true"
        >
            <template #link>
                <a
                    class="cursor-pointer text-decoration-none text-caption text-blue-darken-3"
                    @click="forgotPassword"
                >Forgot password?</a>
            </template>
        </text-field>
        <template #submit>
            Sign in
        </template>
    </form-card>
    <single-action-card>
        <span class="mr-1">Don't have an account?</span>
        <a
            class="cursor-pointer text-decoration-none text-blue-darken-3"
            @click="register"
        >Sign up</a>
    </single-action-card>
</template>

<style scoped>

</style>
